import React from "react";

import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import Typography from "../../../../components/Text";

import css from "../CompanyLinksModal.module.scss";

const DeleteLinkModal = ({ show, onClose, onDelete }: any) => {
	if (!show) {
		return <></>;
	}
	const deleteButtons = [
		<Button key={1} size="large" className={css.button} onClick={onClose}>
			Cancel
		</Button>,
		<Button
			testid="delete-link-modal-submit-button"
			key={2}
			size="large"
			className={css.button}
			onClick={onDelete}
			color="green"
		>
			Yes, Delete
		</Button>,
	];

	const content = (
		<Typography size="sub-heading" weight="semi-bold" color="neutral-9">
			Are you sure you want to delete this link?
		</Typography>
	);

	return <Modal content={content} handleClose={onClose} buttons={deleteButtons} />;
};

export default DeleteLinkModal;
